































































































































import Vue from 'vue'
import SvgElement from '@/components/globals/SvgElement.vue'

export default Vue.extend({
  components: {
    SvgElement,
  },
  props: {
    isPcSingleColumn: {
      type: Boolean,
      default: false,
    },
  },
})
